module.exports = __webpack_public_path__ + "media/country_flags/mh-17f924b6.png";